export default __webpack_public_path__ + "static/media/29467907.dcf83eeb.png";